import Container from "@mui/material/Container";
import { Outlet } from "react-router";
import DashboardLayout from "../DashboardLayout/DashboardLayout";
import NoAccess from "../Errors/NoAccess";
import useSession from "../useSession/useSession";

const OrionSecurePage: React.FC = () => {
  const session = useSession();

  if ((session?.OrionUserGroups?.length ?? 0) > 0) {
    return <Outlet />;
  }
  return (
    <DashboardLayout>
      <Container maxWidth={false}>
        <NoAccess />
      </Container>
    </DashboardLayout>
  );
};

export default OrionSecurePage;
